import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Link } from 'react-location';
import Card from "../Card";

import './Carousel.scss';

const Carousel = ({ cards }) => {
  const doubleCardsName = useMemo(() => [...cards.map((card) => card.name), ...cards.map((card) => card.name)], [cards]);
  const originalItemsLength = useMemo(() => cards.length, [cards]);
  const indicatorContainerRef = useRef(null);
  const carouselContentRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitionEnabled, setTransitionEnabled] = useState(false);
  const [canClick, setCanClick] = useState(true);

  useEffect(() => {
    setTransitionEnabled(true);
  }, []);

  /**
   * Move forward to the next item
   */
  const nextItem = useCallback(() => {
    if (canClick) {
      setCanClick(false);
      setCurrentIndex((prevState) => (prevState <= originalItemsLength ? (prevState + 1) : prevState));
      setTimeout(() => { setCanClick(true) }, 1000);
    }
  }, [canClick, originalItemsLength]);

  /**
   * Move backward to the previous item
   */
  const previousItem = useCallback(() => {
    if (canClick) {
      setCanClick(false);
      setCurrentIndex((prevState) => (prevState > 0 ? prevState - 1 : prevState));
      setTimeout(() => { setCanClick(true) }, 1000);
    }
  }, [canClick]);

  /**
   * Handle if the dots is repeating
   */
  useEffect(() => {
    const active = indicatorContainerRef.current?.querySelector(".dots-active");

    if (active) {
      let index = active.getAttribute("data-index");
      if (index !== null && indicatorContainerRef.current?.scrollTo) {
        indicatorContainerRef.current?.scrollTo({
          left: ((Number(index) - 2) / 5) * 50,
          behavior: "smooth",
        });
      }
    }
  }, [currentIndex]);

  useEffect(() => {
    const element = carouselContentRef.current;

    if (element) {
      const handler = (e) => {
        if (e.propertyName !== 'transform') return;
        if (currentIndex === 0) {
          setTransitionEnabled(false);
          setCurrentIndex(originalItemsLength);
          setTimeout(() => {
            setTransitionEnabled(true)
          }, 0);
        } else if (currentIndex === (originalItemsLength + 1)) {
          setTransitionEnabled(false);
          setCurrentIndex(1);
          setTimeout(() => {
            setTransitionEnabled(true)
          }, 0);
        }
      };

      element.addEventListener('transitionend', handler);

      return () => element.removeEventListener('transitionend', handler);
    }
  }, [currentIndex, originalItemsLength]);


  /**
   * Render N dots for the indicator
   * where N is the number of original items / visibleItemsCount
   */
  const renderDots = useMemo(() => {
    let output = [];

    const calculatedActiveIndex = currentIndex % originalItemsLength;

    for (let index = 0; index < originalItemsLength; index++) {
      let className = "";
  
      if (calculatedActiveIndex === index) {
        className = "dots-active";
      } else {
        if (calculatedActiveIndex === 0) {
          if (calculatedActiveIndex + index <= 2) {
            className = "dots-close";
          } else {
            className = "dots-far";
          }
        } else if (calculatedActiveIndex === originalItemsLength - 1) {
          if (Math.abs(calculatedActiveIndex - index) <= 2) {
            className = "dots-close";
          } else {
            className = "dots-far";
          }
        } else {
          if (Math.abs(calculatedActiveIndex - index) === 1) {
            className = "dots-close";
          } else {
            className = "dots-far";
          }
        }
      }
      output.push(<div key={index} data-index={index} className={className} />);
    }

    return output;
  }, [currentIndex, originalItemsLength]);

  console.log('TR => currentIndex', currentIndex);
  console.log('TR => currentIndex x 724', currentIndex * 724);

  return (
    <article className="carousel">
      <div className="carousel--cards__wrapper">
        <div className="carousel--card__title--wrapper">
          <h4
            className="carousel--card__titles"
          >
            {doubleCardsName.map((cardName, index) => (
              <div
                key={`${cardName}-${index}`}
                style={{
                  transform: `translateY(-${(currentIndex) * 100}%)`,
                  transition: !isTransitionEnabled ? "none" : "transform 1s ease",
                }}
              >
                {cardName}
              </div>
            ))}
          </h4>

          <Link className="discover--link" to={cards[currentIndex % originalItemsLength].url}>
            Découvrir
            <img alt="flèche icon" className="icon__arrow" src="/images/Home/arrow.svg" />
          </Link>
        </div>

        <div
          className="carousel-content__wrapper"
          ref={carouselContentRef}
          style={{
            transform: `translateX(-${currentIndex * 724 + originalItemsLength * 724}px)`,
            transition: !isTransitionEnabled ? "none" : "transform 1s ease",
          }}
        >
          {cards.map((card, index) => (
            <Card
              cardInfo={card}
              handleNext={() => {}}
              handlePrevious={previousItem}
              isExtraPrevious
              isFocus={false}
              isNext={false}
              isTransitionEnabled={isTransitionEnabled}
              key={`${card.name}-extra-previous-${index}`}
            />
          ))}
          {cards.map((card, index) => (
            <Card
              cardInfo={card}
              handleNext={nextItem}
              handlePrevious={previousItem}
              isFocus={currentIndex === index}
              isNext={index > currentIndex}
              isTransitionEnabled={isTransitionEnabled}
              key={card.name}
            />
          ))}
          {cards.map((card, index) => (
            <Card
              cardInfo={card}
              handleNext={nextItem}
              handlePrevious={() => {}}
              isExtraNext
              isFocus={currentIndex >= originalItemsLength && currentIndex === (index + originalItemsLength)}
              isNext={true}
              isTransitionEnabled={isTransitionEnabled}
              key={`${card.name}-extra-next-${index}`}
            />
          ))}
        </div>
      </div>
      <div ref={indicatorContainerRef} className={`indicator-container `}>
        {renderDots}
      </div>
    </article>
  );
};

export default Carousel;
